// var sizesArray = [1400,900,480,765,1000,1100,1300,1500,1700,1900,2000];

var sizesArray = [300,350,400,450,500,550,600,650,700,750,
                  800,850,900,950,1000,1050,1100,1150,1200,
                  1250,1300,1350,1400,1450,1500,1550,1600,
                  1650,1700,1750,1800,1850,1900,1950,2000,2500,4000];

// var sizesArray = [100,425,800,900,1000,1200,2000];
// var sizesArray = [300,600,900,1000,1200];

var imageFormatsArray = [".jpg",".png",".gif",".tif",".tiff",".bmp",".jpeg",".gif",".eps"];

var dataSrcSet = "";

function getLazyLoadImg(laptopUrl,tablateUrl,mobUrl,lowQualityImgUrl,altText,className){
  dataSrcSet = "";
  var i;
  var sizesArrayLength = sizesArray.length;
  for(i=0;i<sizesArrayLength;i++){
    var isLastSize = false;
    if((i+1) === sizesArrayLength){
      isLastSize = true;
    }
    
    var updatedImageUrl = "";
    var size = sizesArray[i];
    if(size>768){
      updatedImageUrl = updateImageUrl(laptopUrl,size);
      if(isLastSize === false){
        dataSrcSet = dataSrcSet+updatedImageUrl+" "+size+"w, ";
      }
      else{
        dataSrcSet = dataSrcSet+updatedImageUrl+" "+size+"w";
      }
    }
    else if(size > 425 && size <= 768){
      if(tablateUrl !== ""){
        updatedImageUrl = updateImageUrl(tablateUrl,size);
        if(isLastSize === false){
        dataSrcSet = dataSrcSet+updatedImageUrl+" "+size+"w, ";
        }
        else{
          dataSrcSet = dataSrcSet+updatedImageUrl+" "+size+"w";
        }
        
      }
      else{
        updatedImageUrl = updateImageUrl(laptopUrl,size);
        if(isLastSize === false){
        dataSrcSet = dataSrcSet+updatedImageUrl+" "+size+"w, ";
        }
        else{
          dataSrcSet = dataSrcSet+updatedImageUrl+" "+size+"w";
        }
      }
    }
    else if(size<=425){
      if(mobUrl !== ""){
        updatedImageUrl = updateImageUrl(mobUrl,size);
        if(isLastSize === false){
        dataSrcSet = dataSrcSet+updatedImageUrl+" "+size+"w, ";
        }
        else{
          dataSrcSet = dataSrcSet+updatedImageUrl+" "+size+"w";
        }
      }
      else if(tablateUrl !== ""){
        updatedImageUrl = updateImageUrl(tablateUrl,size);
        if(isLastSize === false){
        dataSrcSet = dataSrcSet+updatedImageUrl+" "+size+"w, ";
        }
        else{
          dataSrcSet = dataSrcSet+updatedImageUrl+" "+size+"w";
        }
      }
      else{
        updatedImageUrl = updateImageUrl(laptopUrl,size);
        if(isLastSize === false){
        dataSrcSet = dataSrcSet+updatedImageUrl+" "+size+"w, ";
        }
        else{
          dataSrcSet = dataSrcSet+updatedImageUrl+" "+size+"w";
        }
      }
    }
  }
  
//   data-sizes='auto'
  
  var imgClass = '';
  if(className !== undefined && className !== '' && className !== null) {
    imgClass = className + ' lazyload blur-up';
  } else {
    imgClass = 'lazyload img-responsive center-block blur-up';
  }
  
//   var imageTag = "<img class = 'lazyload img-responsive center-block ' alt = '"+altText+"' data-srcset = '"+dataSrcSet+"' data-src='"+laptopUrl+"' src = "+lowQualityImgUrl+"  />";
  
  var imageTag = 
  "<img  alt = '"+altText+"' data-srcset = '"+dataSrcSet+"' src = "+lowQualityImgUrl+" class = '"+imgClass+"'  />";
  
  return imageTag;
}

function updateImageUrl(imageUrl,size){
  var i;
  var imageFormatsArrayLength = imageFormatsArray.length;
  var inputImageFormat = "";
  var updatedImageUrl = "";
  for(i=0;i<imageFormatsArrayLength;i++){
    var format = imageFormatsArray[i];
    var indexOfImgFormat = imageUrl.indexOf(format);
    if(indexOfImgFormat !== -1){
      inputImageFormat = format;
      break;
    }
  }
  
  if(inputImageFormat !== ""){
    var imageUrlArray = imageUrl.split(inputImageFormat);
    updatedImageUrl = imageUrlArray[0]+"_"+size+"x"+inputImageFormat+imageUrlArray[1];
    return updatedImageUrl;
  }
  else{
    return imageUrl
  }
}
